<template>
  <v-col cols="12" sm="12" md="6" :order="isSelected ? 'first' : undefined">
    <v-card
      height="100%"
      :max-height="vehicle ? '350px' : '250px'"
      class="pt-3 d-flex flex-column rounded-lg"
      flat
      :style="{
        cursor: vehicle ? 'pointer' : 'unset',
        border: isSelected
          ? '1px solid rgb(var(--v-theme-primary))'
          : '1px solid rgb(var(--v-theme-primary20))',
        background: isSelected ? 'rgb(var(--v-theme-primary20))' : undefined,
      }"
      @click.stop="showDetails"
    >
      <v-row no-gutters class="align-center">
        <v-col cols="4" class="pl-2">
          <v-img
            lazy-src="/images/car_images/placeholder_car.png"
            :src="getImageSrc()"
            contain
          />
        </v-col>
        <v-col cols="8" style="min-height: 70px">
          <v-card-title class="text-truncate">
            {{ vehicle.name ?? "unnamed vehicle" }}
          </v-card-title>
          <v-card-subtitle class="text-truncate">
            {{ vehicle.licensePlate ?? "unrecorded license plate" }}
          </v-card-subtitle>
          <v-card-text class="d-flex align-center pt-0">
            <v-icon color="primary" size="small" class="mr-1">
              {{ vehicle.fuelTypeIcon }}
            </v-icon>
            {{ vehicle.fuelTypeDisplayText }}
          </v-card-text>
        </v-col>
      </v-row>
      <v-card-actions class="mt-auto">
        <div
          v-if="isSelected"
          class="flex-grow-1 d-flex align-center justify-center text-primary font-weight-medium py-2"
        >
          <v-icon icon="mdi-check-circle" class="mr-1" />
          Selected
        </div>
        <CustomSolidButton fullWidth @click="select" v-else>
          Select
        </CustomSolidButton>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script setup lang="ts">
import type { Vehicle } from "@/domains/vehicles";
import CustomSolidButton from "../ui-elements/buttons/custom-buttons/CustomSolidButton.vue";

const { vehicle, isSelected = false } = defineProps<{
  vehicle: Vehicle;
  /**
   * Whether this card should show as the current selection (checkmark,
   * highlighted border) instead of a "Select" button. Optional - only
   * meaningful to a caller that has its own idea of "selected" (e.g.
   * picking a default trip vehicle); a plain browse-and-pick usage of this
   * gallery has no such concept and can leave it unset.
   */
  isSelected?: boolean;
}>();

const emit = defineEmits<{
  (e: "select", value: Vehicle): void;
  (e: "showDetails", value: Vehicle): void;
}>();

function select() {
  emit("select", vehicle);
}

function showDetails() {
  emit("showDetails", vehicle);
}

function getImageSrc() {
  if (vehicle.imageSrcPaths.length) return vehicle.imageSrcPaths[0];
  // if (vehicle.evModel?.imageUUID) return vehicle.evModel.imageUUID
  return "/images/car_images/placeholder_car.png";
}
</script>
